export default __webpack_public_path__ + "static/media/TheSpider.f4aac478.jpg";